<template lang="pug">
doctype html
div
  .closeDebug(@click="hideEnvFlagDebug" v-if="showClose") {{envFlagDebug?'close':'show'}}
  div(v-if="envFlagDebug" )
    vue-draggable-resizable(:w="w" :h="h" :x="x" :y="y" :z="2005" @dragstop="onDragstop" @dragging="onDrag" :resizable="false" :parent="true" :maxParent="maxParent" :fixed="true")
      .back-container
        .icon-back(@click="reload")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug01.png")
          p  
        .icon-back(@click="windowReload")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug02.png")
          p  
        .icon-back(@click="onCopyUrl" v-clipboard:copy="copyUrl" v-clipboard:success="onCopy")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug03.png")
          p   
        .icon-back(@click="onCopyUrl" v-clipboard:copy="copyPageUrl" v-clipboard:success="onCopy2")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug04.png")
          p
        .icon-back(@click="changePath")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug05.png")
          p
        .icon-back(@click="getInfo")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug06.png")
          p
        .icon-back(@click="goSettoken")
          img(src="http://img.zx.zoenet.cn/maternalte/icon/debug03.png")
          p
  van-popup(v-model="show"
  closeable
  position="top"
  :style="{ height: '80%' }")
    van-field(
      v-model="linkDomainName"
      rows="3"
      autosize
      type="textarea"
      placeholder="")
    van-field(
      v-model="address"
      rows="3"
      autosize
      type="textarea"
      placeholder="")
    van-field(
      v-model="appInfo"
      rows="3"
      autosize
      type="textarea"
      placeholder="")
    van-field(
      v-model="fullAddress"
      rows="3"
      autosize
      type="textarea"
      placeholder="")
    van-button(type="default" @click.native="changeEnvironment()") 获取地址
    van-button(type="default" @click.native="goToPageFull(fullAddress)") 打开拼接新页面
    van-button(type="default" @click.native="goToPageFull(copyUrl)") 打开新页面
    div(style="padding:5px 15px;font-size: 15px;line-height: 1.5;")
      van-radio-group( v-model="queryFlag" direction="horizontal")   
        van-radio( name="1" style="margin-bottom: 10px;") 参数 带
        van-radio( name="2" style="margin-bottom: 10px;") 不带
    div(style="padding:5px 15px;font-size: 15px;line-height: 1.5;")  
      van-radio-group( v-model="linkType" direction="horizontal")   
        van-radio( name="?" style="margin-bottom: 10px;") 连接符 ?
        van-radio( name="&" style="margin-bottom: 10px;") &
    div(style="padding:5px 15px;font-size: 15px;line-height: 1.5;")      
      van-radio-group( v-model="linkDomainName" direction="horizontal")
        van-radio( :name="item.id" v-for="(item, index) in linkDomainNameList" :ket="index" style="margin-bottom: 10px;") {{item.name}}
</template>
<script type="text/ecmascript-6">
	import VueDraggableResizable from '@/pages/common/vue-draggable-resizable';
	import {
		TokenManager,
		Storage
	} from 'vuezx';
	export default {
		components: {
			VueDraggableResizable
		},
		props: {
			menuSrc: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		data() {
			return {
				token: TokenManager.get(),
				showClose: this.Storage.get('envFlagDebug') ? true : false,
				envFlagDebug: this.Storage.get('envFlagDebug') ? true : false,
        w: 180,
        h: 60,
        x: window.innerWidth - 180,
        y: window.innerHeight * 0.85,
        maxParent: [window.innerWidth, window.innerHeight],
				show: false,
        address: '',
        appInfo:localStorage.getItem('appInfoDetail') || '',
        fullAddress: '',
        queryFlag: '1',
        linkType: '?',
        linkDomainName: localStorage.getItem('linkDomainName') || 'https://3003.zx.zoenet.cn/#',
        linkDomainNameList: [
          {
            name: "运维端（platform）- 开发1 https://op.health.dev.zoenet.cn",
            id: 'https://op.health.dev.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 开发3 https://op.health.dev3.zoenet.cn",
            id: 'https://op.health.dev3.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 开发4 https://op.health.dev4.zoenet.cn",
            id: 'https://op.health.dev4.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 开发2 https://op.health.dp.zoenet.cn",
            id: 'https://op.health.dp.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 测试库 https://op.health.t.zoenet.cn",
            id: 'https://op.health.t.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 正式库 https://operation.health.zoenet.cn",
            id: 'https://operation.health.zoenet.cn/#'
          }, {
            name: "运维端（platform）- 正式库 龙岩核酸 https://operation.health.longyan.gov.cn/",
            id: 'https://operation.health.longyan.gov.cn/#'
          },
          {
            name: "公众端（app）- 开发1 https://health.dev.zoenet.cn",
            id: 'https://health.dev.zoenet.cn'
          },
          {
            name: "公众端（app）- 开发3 https://health.dev3.zoenet.cn",
            id: 'https://health.dev3.zoenet.cn'
          },
          {
            name: "公众端（app）- 开发4 https://health.dev4.zoenet.cn",
            id: 'https://health.dev4.zoenet.cn'
          }, {
            name: "公众端（app）- 开发2 https://health.dp.zoenet.cn",
            id: 'https://health.dp.zoenet.cn'
          }, {
            name: "公众端（app）- 测试库 https://health.t.zoenet.cn",
            id: 'https://health.t.zoenet.cn'
          }, {
            name: "公众端（app）- 正式库 https://public.health.zoenet.cn",
            id: 'https://public.health.zoenet.cn'
          },
          {
            name: "医生端（care）- 开发1 https://doctor.health.dev.zoenet.cn",
            id: 'https://doctor.health.dev.zoenet.cn'
          },
          {
            name: "医生端（care）- 开发3 https://doctor.health.dev3.zoenet.cn",
            id: 'https://doctor.health.dev3.zoenet.cn'
          },
          {
            name: "医生端（care）- 开发4 https://doctor.health.dev4.zoenet.cn",
            id: 'https://doctor.health.dev4.zoenet.cn'
          }, {
            name: "医生端（care）- 开发2 https://doctor.health.dp.zoenet.cn",
            id: 'https://doctor.health.dp.zoenet.cn'
          }, {
            name: "医生端（care）- 测试库 https://doctor.health.t.zoenet.cn",
            id: 'https://doctor.health.t.zoenet.cn'
          }, {
            name: "医生端（care）- 正式库 https://doctor.health.zoenet.cn",
            id: 'https://service.health.zoenet.cn'
          },
          {
            name: "运维端（platform）- 本地 http://localhost:6031/#",
            id: 'http://localhost:6031/#'
          },
          {
            name: "公众端（app）- 本地 http://localhost:3331/#/",
            id: 'http://localhost:3331/#'
          },
          {
            name: "公众端（app-health）- 本地 http://localhost:33351/#/",
            id: 'http://localhost:33351/#'
          },
          {
            name: "公众端-自定义表单（app-form）- 本地 http://localhost:3351/#/",
            id: 'http://localhost:3351/#'
          },
          {
            name: "医生端（care）- 本地 http://localhost:3301/#/",
            id: 'http://localhost:3301/#'
          },
          {
            name: "医生端-自定义表单（care-form）- 本地 http://localhost:3341/#/",
            id: 'http://localhost:3341/#'
          },
          {
            name: "昌吉（测试线）http://3005.zx.dev.zoenet.cn/#/",
            id: 'http://3005.zx.dev.zoenet.cn/#'
          },
          {
            name: "昌吉（正式库）https://13005.zx.zoenet.cn/#/",
            id: 'https://13005.zx.zoenet.cn/#'
          },
          {
            name: "母婴（开发）http://4004.zx.dev.zoenet.cn/#/",
            id: 'http://4004.zx.dev.zoenet.cn/#'
          },
          {
            name: "母婴（测试线）https://3003.zx.dev.zoenet.cn/#/",
            id: 'https://3003.zx.dev.zoenet.cn/#'
          },
          {
            name: "母婴（正式库）https://3003.zx.zoenet.cn/#/",
            id: 'https://3003.zx.zoenet.cn/#'
          },
          {
            name: "母婴- 本地 http://localhost:4004/#/",
            id: 'http://localhost:4004/#'
          },
        ],
        copyUrl: '',//复制
        copyPageUrl: '',//复制全部路径
			};
		},
		watch: {},
		mounted() { },
		created() {
    },
		methods: {
      onDrag(x, y) {
        this.x = x;
        this.y = y;
      },
      onDragstop() {
      },
      hideEnvFlagDebug() {
        this.envFlagDebug = !this.envFlagDebug
      },
      //刷新
      reload() {
        this.$emit('reload')
      },
      //改变地址
      changePath() {
        history.replaceState({}, '', location.protocol + '//' + location.host + '#' + location.pathname + location.search);
        window.location.reload()
      },
      //刷新
      windowReload() {
        window.location.reload()
      },
      getInfo() {
        this.show = true;
        this.address = `${window.location.hash.replace('#', '')}`
      },
      //关闭弹窗
      closeShow() {
        this.show = false;
        localStorage.setItem('linkDomainName', this.linkDomainName)
      },
      // 获取地址
      changeEnvironment() {
        var _this = this;
        let query = ''
        if (this.queryFlag == '1') {
          query = `${this.linkType}`
        }
        this.fullAddress = `${this.linkDomainName}${this.address}${query}${this.appInfo}`
      },
      // 复制路径
      onCopyUrl(type) {
        //复制
        this.copyUrl = `${this.linkDomainName}${this.$route.fullPath}${this.$route.fullPath.includes('?')?'&':'?'}${this.appInfo}`
        //复制全部路径
        this.copyPageUrl = this.$route.matched[this.$route.matched.length - 1].components.default.__file
      },
      onCopy() {
        this.toast('复制路径成功')
      },
      onCopy2() {
        this.toast('复制页面路径成功')
      },
      // 跳转
      goToPageFull(url) {
        window.open(url)
      },
			//跳转settoken
			goSettoken() {
				this.$router.push({ path: '/common/settoken', query: { returnUrl: location.hash } })
			},
		}
	};
</script>
<style lang="less" scoped>
.back-container {
  text-align: center;
  float: right;
}

.icon-back {
  height: 40px;
  width: 40px;
  margin-right: 10px;
  background: #ffffff;
  z-index: 100;
  text-align: center;
  float: left;
  border-radius: 50%;

  img {
    width: 30px;
    margin-top: 5px;
  }

  p {
    font-size: 22px;
    color: #333333;
    padding-top: 8px;
  }
}

.closeDebug {
  position: fixed;
  right: 0;
  bottom: 240px;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
}
</style>
